<template>
	<div class="container">
		<div class="list-title">Privacy Policy</div>
		<div class="list-item">SKYN respects and protects the personal privacy of all users of the Services. In order to provide you with a more accurate and personalized service, SKYN will use and disclose your personal information as set forth in this Privacy Policy. However, SKYN will treat such information with a high degree of diligence and duty of care. Except as otherwise provided in this Privacy Policy, SKYN will not disclose such information to outside parties or provide it to third parties without your prior permission, and SKYN may update this Privacy Policy from time to time. By agreeing to the SKYN Service Use Agreement, you are deemed to have agreed to this Privacy Policy in its entirety. This Privacy Policy is an integral part of the SKYN Service Usage Agreement.</div>
		<div class="list-item">1. Scope of Application</div>
		<div class="list-item">a) The personal registration information you provide to SKYN when you register for a SKYN account, as requested by SKYN.</div>
		<div class="list-item">b) information on your browser and computer that SKYN automatically receives and records when you use the SKYN Web Services, or visit the SKYN Platform web pages, including but not limited to your P address, type of browser, language used, date and time of access, information on hardware and software features, and records of web pages you request; c) Personal data of users obtained by SKYN from business partners through legitimate means. You understand and agree that the following information is not subject to this Privacy Policy.</div>
		<div class="list-item">c) information about keywords you enter when using the search services provided by the SKYN Platform.</div>
		<div class="list-item">d) Data collected by SKYN about information you post on SKYN, including but not limited to participation in events, transaction information and evaluation details.</div>
		<div class="list-item">e) Violations of laws or violations of SKYN's rules and the measures SKYN has taken against you.</div>
		<div class="list-item">2.Information Use</div>
		<div class="list-item">a) SKYN will not provide, sell, rent, share or trade your personal information to any unrelated third party unless it has your prior permission or unless such third party and SKYN (including SKYN affiliates), individually or jointly, provide services to you, and upon the termination of such services, it will be prohibited from accessing all such information, including those to which it previously had access. information.</div>
		<div class="list-item">b) SKYN also does not permit any third party to collect, compile, sell or distribute your personal information by any means without compensation. If any user of the SKYN Platform engages in any of the above activities, SKYN reserves the right to immediately terminate the service agreement with such user upon discovery.</div>
		<div class="list-item">c) For the purpose of serving users, SKYN may use your personal information to provide you with information of interest to you, including but not limited to sending you information about its products and services, or sharing information with SKYN partners so that they can send you information about their products and services (the latter requires your prior consent).</div>
		<div class="list-item">3. Disclosure of Information</div>
		<div class="list-item">SKYN will disclose your personal information, in whole or in part, in accordance with your personal wishes or as required by law, in the following circumstances</div>
		<div class="list-item">a) To a third party with your prior consent.</div>
		<div class="list-ite">b)when it is necessary to share your personal information with a third party in order to provide the products and services you have requested.</div>
		<div class="list-item">c)To third parties or administrative or judicial bodies in accordance with the relevant provisions of the law, or the requirements of administrative or judicial bodies.</div>
		<div class="list-item">d) If you are required to disclose to a third party in the event of a violation of relevant Chinese laws or regulations or the SKYN service agreement or related rules.</div>
		<div class="list-item">e)If you are an eligible IPR complainant and have filed a complaint, disclosure to the Respondent is required at the request of the Respondent in order for the parties to deal with possible disputes over rights.</div>
		<div class="list-item">f) If any party to a transaction created on the SKYN platform fulfills or partially fulfills its obligations under the transaction and makes a request for disclosure, SKYN reserves the right to decide to provide that user with the necessary information such as the contact information of the other party to its transaction in order to facilitate the completion of the transaction or the resolution of the dispute.</div>
		<div class="list-item">g) Other disclosures that SKYN deems appropriate in accordance with laws, regulations or website policies.</div>
		<div class="list-item">4.Information Storage and Exchange</div>
		<div class="list-item">Information and materials collected about you by SKYN will be stored on the servers of SKYN and/or its affiliates and may be transferred to, accessed, stored and displayed outside of your country, region or location where SKYN collects information and materials.</div>
		<div class="list-item">a) If you do not reject cookies, SKYN may set or retrieve cookies on your computer to enable you to log in or use services or features of the SKYN Platform that rely on cookies. SKYN uses cookies to provide you with more thoughtful and personalized services, including the promotion of services.</div>
		<div class="list-item">b) You have the right to choose to accept or decline cookies, and you may refuse cookies by modifying your browser settings; however, if you choose to decline cookies, you may not be able to log in or use the SKYN web services or features that rely on cookies.</div>
		<div class="list-item">c) Information about you obtained through cookies set by SKYN will be subject to this policy.</div>
		<div class="list-item">6. Information Security</div>
		<div class="list-item">a) SKYN accounts are protected by security features, so please keep your user name and password information secure, and SKYN will ensure that your information is not lost, misused or altered through security measures such as encryption of your password. Notwithstanding the aforementioned security measures, please note that there are no "perfect security measures" on the information network.</div>
		<div class="list-item">a) SKYN accounts are protected by security features, so please keep your user name and password information secure, and SKYN will ensure that your information is not lost, misused or altered through security measures such as encryption of your password. Notwithstanding the aforementioned security measures, please note that there are no "perfect security measures" on the information network.</div>
		<div class="menu-footer"></div>



	</div>
</template>


<script>
	
import Vue from 'vue'
// import wx from 'weixin-js-sdk'
// var wx = require('weixin-js-sdk');

export default {
  name: 'app',
  components: {
  },
  data(){
	  return{
	  }
  },
  
  computed:{
	  richTitle1(){
		  var title = this.brightenKeyword('在注册LILO前请务必审慎阅读LILO使用协议、充分理解协议中相关条款内容。一旦注册LILO，即视为已了解并同意该协议的各项内容。《LILO使用协议》为获得揭阳市顺资电子实业有限公司（以下或简称“顺资”）提供的LILO APP服务（以下或简称“LILO”），请务必审慎阅读、充分理解本协议所有条款。一旦注册，则视为了解并完全接受本协议的全部内容，包括顺资对使用协议所做的任何修改。如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人的陪同下阅读和判断是否同意本协议，并特别注意7、未成年人使用条款。','7、未成年人使用条款。');
		  return title;
	  },
	  
  },
  
 
  mounted() {
  },
  
  
  beforeDestroy() {
  },
  
  created() {
		window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  
  destroyed() {
		window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  
 
  methods:{
		beforeunloadFn(e) {
			console.log('刷新或关闭')
		}, 
		
	  //搜索高亮
		brightenKeyword(val, keyword) {
		  if (keyword.length > 0) {
			val = val + "";
			var item = keyword;
			if (val.indexOf(item) !== -1 && item !== "") {
				val = val.replace(
				  new RegExp(item,'g'),
				  '<font color="#ff0000">' + item + "</font>"
				);
			  }
			return val;
		  } else {
			return val;
		  }
		},
		

		okButtonClick(e){
			var infoString = "";
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
			var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
			if (isAndroid) {
				window.Android.okButtonClick(infoString);
			} else if (isiOS) {
				window.webkit.messageHandlers.okButtonClick.postMessage(infoString) //url为分享的链接地址
			}
		},
		
		refuseButtonClick(e){
			var infoString = "";
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
			var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
			if (isAndroid) {
				window.Android.refuseButtonClick(infoString);
			} else if (isiOS) {
				window.webkit.messageHandlers.refuseButtonClick.postMessage(infoString) //url为分享的链接地址
			}
		}

	}

}
</script>

<style>
	#app {
	/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  text-align: center;
	  color: #2c3e50;
	  margin-top: 60px; */
	  padding: 0;
	  margin: 0;
	}

	.container{
		padding: 0;
		margin: 0;
		height: 100vh;
		width: 100vw;
		position: relative;
	}
	
	.title1{
		margin-left: 10px;
		margin-right: 10px;
		margin-top: 20px;
		font-size: 18px;
		color: black;
	}

	
	.list-title{
		margin-left: 10px;
		margin-right: 10px;
		margin-top: 20px;
		font-size: 17px;
		font-weight: bold;
	}
	
	.list-item{
		margin-left: 10px;
		margin-right: 10px;
		margin-top: 20px;
		font-size: 15px;
		color: black;
	}
	
	.list-item-5{
		margin-left: 10px;
		margin-right: 10px;
		margin-top: 5px;
		font-size: 15px;
		color: black;
	}
	
	.list-item2{
		margin-left: 10px;
		margin-right: 10px;
		margin-top: 10px;
		font-size: 14px;
		color: black;
	}
	
	.list-item3{
		margin-left: 10px;
		margin-right: 10px;
		margin-top: 10px;
		font-size: 13px;
		color: black;
	}
	
	.menu-footer{
		height: 34px;
	}

</style>
